import { withNamespace } from '../helper';

const namespace = '@APPLICATION';

export const GET_APPLICATION = withNamespace('GET_APPLICATION', namespace);
export const GET_APPLICATION_SUCCESS = withNamespace('GET_APPLICATION_SUCCESS', namespace);

export const GET_APPLICATIONS = withNamespace('GET_APPLICATIONS', namespace);
export const GET_APPLICATIONS_SUCCESS = withNamespace('GET_APPLICATIONS_SUCCESS', namespace);

export const GET_VARIANT_GROUPS = withNamespace('GET_VARIANT_GROUPS', namespace);
export const GET_VARIANT_GROUPS_SUCCESS = withNamespace('GET_VARIANT_GROUPS_SUCCESS', namespace);
